import { styled } from "@mui/material/styles";
import Grid, { GridProps } from "@mui/material/Grid";

export type EmtGridContainerProps = GridProps & { nonce?: string };

const GridContainer = styled(Grid)(() => ({
  margin: 0,
  padding: 0,
}));

export function EmtGridContainer(props: EmtGridContainerProps) {
  const {
    container = true,
    columnSpacing = { xs: 3, lg: 3 },
    rowSpacing = { xs: 3, lg: 3 },
    ...rest
  } = props;
  return (
    <GridContainer
      container={container}
      columnSpacing={columnSpacing}
      rowSpacing={rowSpacing}
      {...rest}
    />
  );
}
